import { CesiumObj } from '@/components/GIS/CesiumObj'

/** 去往当前位置  */
export const toCameraPosition = async (coord: { lat: number; lng: number },range?:number) => {
  const cesiumobj = await CesiumObj.getInstance()
  cesiumobj.cameraController.overlook(coord,range)
}

/**
 * 获取一个随机的时间戳，范围在当前时间之前48小时和当前时间之后10小时之间
 * @returns 时间戳
 */
export function getRandomTimestampWithinRange() {
  // 获取当前时间戳
  const now = Date.now()

  // 定义时间范围（以小时为单位）
  const minHours = 10
  const maxHours = 48

  // 计算时间范围的毫秒数
  const minMilliseconds = minHours * 60 * 60 * 1000
  const maxMilliseconds = maxHours * 60 * 60 * 1000

  // 生成随机的毫秒数
  const randomMilliseconds =
    Math.floor(Math.random() * (maxMilliseconds - minMilliseconds)) + minMilliseconds

  // 计算随机时间戳
  const randomTimestamp = now - randomMilliseconds

  return randomTimestamp
}
